import {
  ClockCircleOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  ReloadOutlined,
  PlayCircleOutlined,
  InfoCircleOutlined,
  DeleteOutlined,
  ScheduleOutlined,
} from "@ant-design/icons";

// Интервалы обновления
export const REFRESH_INTERVAL = 30000; // 30 секунд

// Маппинг названий очередей для отображения
export const QUEUE_DISPLAY_NAMES: Record<string, string> = {
  reviews: "Отзывы",
  products: "Товары",
  price_orchestrator: "Цены: оркестратор",
  price_ozon: "Цены: Ozon",
  price_wb: "Цены: WB",
  auth_tokens: "Авторизация: токены",
  stock_management: "Управление остатками",
  ozon: "Ozon: операции",
  ya: "Яндекс Маркет",
  fbs_orders: "FBS заказы (аналитика)",
  deliveries_wb: "Поставки WB",
  wb_slots: "Охота за слотами WB",
};

// Маппинг названий задач
export const JOB_NAME_DISPLAY_MAP: Record<string, string> = {
  "reviews:wb_load_new": "Загрузка новых отзывов WB",
  "reviews:wb_load_old": "Загрузка старых отзывов WB",
  "reviews:wb_send": "Отправка ответов WB",
  "reviews:wb_approve": "Апрув отзывов WB",
  "reviews:wb_reset": "Сброс статуса WB",
  "reviews:wb_generate": "Генерация ответов WB",
  "reviews:ozon_load_new": "Ozon: новые отзывы (один проход)",
  "reviews:ozon_load_new_daemon": "Ozon: новые отзывы (демон, +10 мин)",
  "reviews:ozon_load_new_daemon_ensure": "Ozon: проверка демона новых отзывов",
  "reviews:ozon_load_viewed_awaiting":
    "Ozon: просмотренные, ждут ответа (раз в сутки)",
  "reviews:ozon_load_viewed_daily": "Ozon: прочие просмотренные (раз в сутки)",
  "reviews:ozon_load_old": "Загрузка старых отзывов Ozon",
  "reviews:ozon_send": "Отправка ответов Ozon",
  "reviews:ozon_approve": "Апрув отзывов Ozon",
  "reviews:ozon_reset": "Сброс статуса Ozon",
  "reviews:ozon_generate": "Генерация ответов Ozon",
  "products:wb_load": "Загрузка товаров WB",
  "products:wb_classify_category_brand":
    "WB: классификация категории и бренда (LLM)",
  "products:ozon_load": "Загрузка товаров Ozon",
  "auth_tokens:update_ozon_cookie": "Авторизация: обновить Ozon cookie",
  "fbs_orders:sync_hot": "FBS заказы: sync 48ч",
  "fbs_orders:day_close": "FBS заказы: day-close + prune",
  "deliveries_wb:poll_slots": "WB поставки: опрос слотов",
  "deliveries_wb:poll_slots_ensure": "WB поставки: watchdog демона",
  "deliveries_wb:update_supply_cookie": "WB поставки: обновить cookie",
  "deliveries_wb:plan_supply": "WB поставки: забронировать слот",
  "wb_slots:ensure": "Охота слотов WB: watchdog",
  "stock_management:ozon_load_reserved": "Ozon: Загрузка резервов FBS",
  "stock_management:ozon_send_remnants": "Ozon: Отправка остатков в МП",
  "stock_management:ozon_load_warehouse_stocks":
    "Ozon: Загрузка остатков со склада МП",
  "ozon:send_prices": "Ozon: Отправка цен",
  "ozon:load_sales": "Ozon: Загрузка продаж",
  "ya:send_prices": "Яндекс: Отправка цен",
  "ya:send_remnants": "Яндекс: Отправка остатков",
  "ya:load_reserved": "Яндекс: Загрузка резервов",
  "ya:load_sales": "Яндекс: Загрузка продаж",
  "ya:update_sk": "Яндекс: Обновить SK/сессию",
  "sber:send_prices": "Сбер: Отправка цен",
  "sber:send_remnants": "Сбер: Отправка остатков",
  "sber:load_reserved": "Сбер: Загрузка резервов",
  "ali:send_prices": "Ali: Отправка цен",
  "ali:send_remnants": "Ali: Отправка остатков",
  "ali:load_reserved": "Ali: Загрузка резервов",
  "ali:update_product_code": "Ali: Обновить product_code",
};

// Настройки статистики
export const STATISTICS_CONFIG = {
  waiting: {
    title: "Ожидают",
    color: "#1890ff",
    icon: ClockCircleOutlined,
  },
  delayed: {
    title: "Отложены",
    color: "#722ed1",
    icon: ScheduleOutlined,
  },
  active: {
    title: "Выполняются",
    color: "#faad14",
    icon: ClockCircleOutlined,
  },
  completed: {
    title: "Завершены",
    color: "#52c41a",
    icon: CheckCircleOutlined,
  },
  failed: {
    title: "Ошибки",
    color: "#ff4d4f",
    icon: ExclamationCircleOutlined,
  },
};

// Настройки вкладок
export const TABS_CONFIG = [
  {
    key: "1",
    icon: ClockCircleOutlined,
    label: "Ожидающие",
    statusKey: "waiting" as const,
  },
  {
    key: "2",
    icon: ScheduleOutlined,
    label: "Отложенные",
    statusKey: "delayed" as const,
  },
  {
    key: "3",
    icon: ReloadOutlined,
    label: "Активные",
    statusKey: "active" as const,
    iconProps: { spin: true },
  },
  {
    key: "4",
    icon: CheckCircleOutlined,
    label: "Завершенные",
    statusKey: "completed" as const,
  },
  {
    key: "5",
    icon: ExclamationCircleOutlined,
    label: "С ошибками",
    statusKey: "failed" as const,
  },
];

// Настройки колонок для ожидающих задач
export const WAITING_JOBS_COLUMNS = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 80,
  },
  {
    title: "Очередь",
    dataIndex: "queue",
    key: "queue",
    width: 140,
  },
  {
    title: "Название",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Данные",
    dataIndex: "data",
    key: "data",
  },
  {
    title: "Время создания",
    dataIndex: "timestamp",
    key: "timestamp",
  },
  {
    title: "Приоритет",
    dataIndex: "priority",
    key: "priority",
  },
  {
    title: "Действия",
    key: "actions",
    width: 100,
  },
];

// Настройки колонок для отложенных задач
export const DELAYED_JOBS_COLUMNS = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 80,
  },
  {
    title: "Очередь",
    dataIndex: "queue",
    key: "queue",
    width: 140,
  },
  {
    title: "Название",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Данные",
    dataIndex: "data",
    key: "data",
  },
  {
    title: "Время создания",
    dataIndex: "timestamp",
    key: "timestamp",
  },
  {
    title: "Запуск",
    dataIndex: "runAt",
    key: "runAt",
  },
  {
    title: "Задержка",
    dataIndex: "delay",
    key: "delay",
  },
  {
    title: "Действия",
    key: "actions",
    width: 100,
  },
];

// Настройки колонок для завершенных задач
export const COMPLETED_JOBS_COLUMNS = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 80,
  },
  {
    title: "Очередь",
    dataIndex: "queue",
    key: "queue",
    width: 140,
  },
  {
    title: "Название",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Статус",
    key: "status",
  },
  {
    title: "Время создания",
    dataIndex: "timestamp",
    key: "timestamp",
  },
  {
    title: "Время завершения",
    dataIndex: "finishedOn",
    key: "finishedOn",
  },
  {
    title: "Ошибка",
    dataIndex: "failedReason",
    key: "failedReason",
  },
];

// Настройки колонок для задач по расписанию
export const TASKS_COLUMNS = [
  {
    title: "Название",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Расписание",
    dataIndex: "schedule",
    key: "schedule",
  },
  {
    title: "Последний запуск",
    dataIndex: "jobName",
    key: "lastRun",
  },
  {
    title: "Действия",
    key: "actions",
  },
];

// Настройки таблиц
export const JOBS_TABLE_PAGE_SIZE = 20;
export const TABLE_CONFIG = {
  pagination: { pageSize: JOBS_TABLE_PAGE_SIZE },
  size: "small" as const,
  rowKey: "id",
};

// Настройки кнопок
export const BUTTON_CONFIG = {
  refresh: {
    icon: ReloadOutlined,
    text: "Обновить",
  },
  autoRefresh: {
    enableText: "Включить автообновление",
    disableText: "Остановить автообновление",
  },
  triggerTask: {
    icon: PlayCircleOutlined,
    text: "Запустить",
  },
  clearArchive: {
    icon: DeleteOutlined,
    text: "Очистить архив",
  },
  clearWaiting: {
    text: "Очистить ожидающие",
  },
  removeJob: {
    text: "Удалить",
  },
};

// Настройки тегов
export const TAG_CONFIG = {
  autoRefresh: {
    enabled: {
      color: "blue",
      icon: ClockCircleOutlined,
      text: "Автообновление каждые 5 сек",
    },
    disabled: {
      color: "default",
      icon: ClockCircleOutlined,
      text: "Автообновление отключено",
    },
  },
  jobStatus: {
    error: {
      color: "red",
      icon: ExclamationCircleOutlined,
      text: "Ошибка",
    },
    completed: {
      color: "green",
      icon: CheckCircleOutlined,
      text: "Завершен",
    },
    waiting: {
      color: "blue",
      icon: ClockCircleOutlined,
      text: "Ожидает",
    },
  },
};

// Настройки карточек
export const CARD_CONFIG = {
  error: {
    style: {
      marginBottom: 16,
      backgroundColor: "#fff2f0",
      borderColor: "#ffccc7",
    },
  },
  statistics: {
    title: "Статистика очереди",
  },
  tasks: {
    title: "Управление задачами по расписанию",
  },
};

// Настройки иконок
export const ICON_CONFIG = {
  info: {
    style: { color: "rgba(0,0,0,.45)" },
  },
};

// Настройки текстов
export const TEXT_CONFIG = {
  noData: "Нет данных",
  lastUpdate: "Обновлено:",
  noPriority: "-",
  noError: "-",
  noFinishedTime: "-",
};
